<template>
  <div class="el-table" :style="{ height: tableHeight + 'px' }">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-input v-model="searchText" placeholder="请输入文件名" clearable class="search-input" size="small"
        @keyup.enter.native="fetchData" />
      <el-input v-model="moduleText" placeholder="请输入模块名称" clearable class="search-input" size="small"
        @keyup.enter.native="fetchData" />
      <CtDatePicker v-model="dateRange" placeholder="请选择创建日期" :show-time="true" :type="'daterange'"></CtDatePicker>
      <el-button type="primary" size="small" @click="fetchData">查询</el-button>
    </div>
    <el-table ref="singleTable" v-loading="loading" class="single-table" :data="tableData"
      style="width: 100%; height: 100%" empty-text="暂无数据" :border="false" :height="tableHeight"
      :header-cell-style="{ background: '#F0F2F5', color: '#333333', fontWeight: '400', borderRight: '1px solid transparent' }">
      <template v-if="activeType == '导入任务'">
        <el-table-column align="left" prop="name" label="模块名称" width="120">
          <template slot-scope="scope">
            {{ scope.row.moduleName }}
          </template>
        </el-table-column>
        <el-table-column align="left" prop="fileName" label="导入文件名" width="150">
          <template slot-scope="scope">
            <el-tooltip :content="contentHover" :disabled="isShowTooltip" placement="left" effect="light"
              popper-class="tooltip-import">
              <div class="ellipsis" style="flex-shrink: 1" @mouseover="onMouseOver(scope.row.fileName, scope.row.id)">
                <span :ref="scope.row.id">{{ `${scope.row.fileName || ""}` }}</span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="status" label="任务状态" width="90">
          <template slot-scope="scope">
            <div class="status-box" :style="{ color: getStatusColor(scope.row.taskStatus) }">
              <span class="dot" :style="{ backgroundColor: getStatusColor(scope.row.taskStatus) }"></span>
              <span v-if="scope.row.taskStatus == 3 && scope.row.errorMsg">
                <el-tooltip effect="light" :content="scope.row.errorMsg" placement="left" popper-class="tooltip-import">
                  <span>
                    {{ getStatusText(scope.row.taskStatus) }}
                  </span>
                </el-tooltip>
              </span>
              <span v-else>{{ getStatusText(scope.row.taskStatus) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="time" label="导入时间" width="160">
          <template slot-scope="scope">{{ scope.row.createTime }}</template>
        </el-table-column>
        <el-table-column align="left" prop="exportNum" label="预计导入量">
          <template slot-scope="scope">{{ scope.row.estimateCount }}</template>
        </el-table-column>
        <el-table-column align="left" prop="isNum" label="实际导入量">
          <template slot-scope="scope">{{ scope.row.actualCount }}</template>
        </el-table-column>
        <el-table-column align="left" prop="failNum" label="失败数">
          <template slot-scope="scope">{{ scope.row.failCount }}</template>
        </el-table-column>
      </template>
      <template v-else>
        <el-table-column align="left" prop="name" label="模块名称" width="120">
          <template slot-scope="scope">{{ scope.row.moduleName }}</template>
        </el-table-column>
        <el-table-column align="left" prop="fileName" label="导出文件名" :width="fileNameWidth">
          <template slot-scope="scope">
            <el-tooltip :content="contentHover" :disabled="isShowTooltip" placement="left" effect="light"
              popper-class="tooltip-import">
              <div class="ellipsis" style="flex-shrink: 1" @mouseover="onMouseOver(scope.row.fileName, scope.row.id)">
                <span :ref="scope.row.id">{{ `${scope.row.fileName || ""}` }}</span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="status" label="任务状态" width="180">
          <template slot-scope="scope">
            <div class="status-box" :style="{ color: getStatusColor(scope.row.taskStatus) }">
              <span class="dot" :style="{ backgroundColor: getStatusColor(scope.row.taskStatus) }"></span>
              <span v-if="scope.row.taskStatus == 3 && scope.row.errorMsg">
                <el-tooltip effect="light" :content="scope.row.errorMsg" placement="left" popper-class="tooltip-import">
                  <span>
                    {{ getStatusText(scope.row.taskStatus) }}
                  </span>
                </el-tooltip>
              </span>
              <span v-else>{{ getStatusText(scope.row.taskStatus) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="time" label="导出时间" width="230">
          <template slot-scope="scope">{{ scope.row.createTime }}</template>
        </el-table-column>
      </template>

      <el-table-column label="操作" :width="computedActWidth" fixed="right">
        <template slot-scope="scope">
          <div class="operate-btn">
            <el-button v-if="scope.row.fileUrl" type="text" size="small" plain @click="download(scope.row)">
              下载{{ scope.row.operationName }}文件
            </el-button>
            <el-button v-if="scope.row.failFileUrl" type="text" size="small" plain
              @click="download(scope.row, 'failFileUrl')">
              下载失败数据
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div ref="searchContainer" class="user-center-list_page flex-end" style="margin-top: 19px">
      <el-pagination :current-page="current" :page-sizes="[10, 20, 30, 50]" :page-size="10"
        layout="total, prev, pager, next,sizes, jumper" :total="total" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
  </div>
</template>
<script>
import { apiExportPage } from "@/api/user"

export default {
  name: "ImportExportTable",
  props: {
    activeType: {
      type: String,
      default: "导入任务"
    },
    operationType: {
      type: Number,
      default: 0
    },
    listData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      current: 1,
      size: 10,
      total: 0,
      tableData: [],
      tableHeight: 700,
      searchText: "",
      moduleText: "",
      dateRange: [],
      loading: false,
      contentHover: "",
      isShowTooltip: false,
      downloadThrottle: false, // 添加节流标志
      throttleDelay: 1000, // 节流延迟时间(毫秒)
      // 任务状态 1进行中 2成功 3失败 4部分成功
      statusList: [
        { label: "进行中", value: 1, color: "#3296FA" },
        { label: "成功", value: 2, color: "#52BD49" },
        { label: "失败", value: 3, color: "#FF4D4F" },
        { label: "部分成功", value: 4, color: "#FAAD14" }
      ]
    }
  },
  computed: {
    computedActWidth() {
      // 可以根据实际业务逻辑调整
      const hasFileUrl = this.tableData.some(row => row.fileUrl)
      const hasFailFileUrl = this.tableData.some(row => row.failFileUrl)

      let buttonCount = 0
      if (hasFileUrl) buttonCount++
      if (hasFailFileUrl) buttonCount++
      if (buttonCount == 1) {
        if (this.activeType == "导出任务") {
          return 120
        }
        return 120
      }
      return buttonCount * 60 + 100
    },
    fileNameWidth() {
      // 可以根据实际业务逻辑调整
      const hasFileUrl = this.tableData.some(row => row.fileUrl)
      const hasFailFileUrl = this.tableData.some(row => row.failFileUrl)
      let buttonCount = 0
      if (hasFileUrl) buttonCount++
      if (hasFailFileUrl) buttonCount++
      if (buttonCount <= 1) {
        return 350
      }
      return buttonCount * 60 + 80
    }
  },
  watch: {
    listData(newVal) {
      if (newVal?.total > 0) {
        const { records, total } = newVal
        this.total = total
        setTimeout(() => {
          this.loading = false
        }, 300)
        setTimeout(() => {
          this.tableData = records
          this.$nextTick(() => {
            this.$refs.singleTable && this.$refs.singleTable.doLayout()
          })
        }, 500)
      }
    }
  },
  created() { },
  mounted() {
    const _this = this
    // 根据窗口变化适应table高度
    window.onresize = function () {
      setTimeout(() => {
        _this.restCountTabHeight()
      }, 30)
    }
    this.restCountTabHeight()
  },
  methods: {
    fetchData() {
      this.current = 1
      this.initExportList()
    },

    initExportList() {
      const { current, size, operationType, searchText, moduleText, dateRange } = this
      this.loading = true
      const params = {
        current: current,
        size,
        param: {
          operationType,
          fileName: searchText || undefined,
          moduleName: moduleText || undefined,
          createTimeStart: dateRange && dateRange.length >= 1 ? dateRange[0] : undefined,
          createTimeEnd: dateRange && dateRange.length >= 2 ? dateRange[1] : undefined
        }
      }
      apiExportPage(params)
        .then(res => {
          if (res.success) {
            const { records, total } = res.data
            this.total = total
            setTimeout(() => {
              this.loading = false
            }, 300)
            setTimeout(() => {
              this.tableData = records
              this.$nextTick(() => {
                this.$refs.singleTable && this.$refs.singleTable.doLayout()
              })
            }, 500)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    download(row, type) {
      // 节流控制，防止频繁点击
      if (this.downloadThrottle) {
        return
      }

      this.downloadThrottle = true

      try {
        const url = type ? row.failFileUrl : row.fileUrl
        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const a = document.createElement("a")
            a.download = row.fileName || "download"
            a.href = URL.createObjectURL(blob)
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            URL.revokeObjectURL(a.href)
          })
      } finally {
        // 延迟重置节流标志
        setTimeout(() => {
          this.downloadThrottle = false
        }, this.throttleDelay)
      }
    },

    handleSizeChange(val) {
      this.size = val
      this.initExportList()
    },
    handleCurrentChange(val) {
      this.current = val
      this.initExportList()
    },
    getClientInfo() {
      const space = 100 // 留白空间
      const tabBar = 154 // layout之类固定的高度
      return parseInt(window.innerHeight) - tabBar - space
    },

    // 重新计算表格高度
    restCountTabHeight(timer = 30) {
      setTimeout(() => {
        this.tableHeight = window.innerHeight - 135 - 72
      }, timer)
    },
    getStatusText(val) {
      if (!val) {
        return ""
      }
      return this.statusList.find(item => item.value === val).label
    },
    getStatusColor(val) {
      if (!val) {
        return "#fff"
      }
      const status = this.statusList.find(item => item.value === val)
      return status ? status.color : "#fff" // 默认颜色
    },
    onMouseOver(str, id) {
      if (!str) {
        return
      }
      // 内容超出，显示文字提示内容
      const tag = this.$refs[id]
      const parentHeight = tag.parentNode.offsetHeight // 获取元素父级可视宽度
      const contentHeight = tag.offsetHeight // 获取元素可视宽度
      if (contentHeight <= parentHeight) {
        this.isShowTooltip = true
      } else {
        this.isShowTooltip = false
      }
      // 鼠标悬停后显示的内容
      this.contentHover = str
    }
  }
}
</script>
<style lang="scss" scoped>
.el-table {
  width: 100%;
}

.single-table {
  ::v-deep .el-table__row td {
    padding: 11px 0;
  }
}

.search-bar {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  align-items: center;

  .hander {
    cursor: pointer;
    font-size: 14px;
    color: #525253;

    &:hover {
      color: #409eff;
    }
  }
}

.search-input {
  width: 200px;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 5px;
}

.status-box {
  display: flex;
  align-items: center;
}

.el-button--text:hover,
.el-button--text:active,
.el-button--text:focus {
  background: transparent !important;
  border-color: transparent !important;
}

.file-name {
  @include ellipsis-single(100%);
}

.operate-btn {
  display: flex;
}

.ellipsis {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  /* 这里是超出几行省略 */
  overflow: hidden;
}
</style>
